export function removeItem<T>(arr: Array<T>, value: T): Array<T> {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }

  return arr;
}

export function getUnrepeatedElements<T>(arr: Array<T>): Array<T> {
  return arr.filter((x) => arr.indexOf(x) === arr.lastIndexOf(x));
}

export function chunks<T>(array: T[], size: number): T[][] {
  return [...Array(Math.ceil(array.length / size))].map((_, i) => array.slice(i * size, i * size + size));
}
